export const FLOATING_ICON_OFFSET_X = 40;
export const FLOATING_ICON_OFFSET_Y = 20;
